import { Tooltip } from "@deere/fuel-react";
import _ from "lodash";
import { toast } from "react-toastify";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT, REST_URL } from "../../constants/constants";
import { log } from "../../Helper";
import { CustomToolTipCMR, CustomToolTipDelete, CustomToolTipDownload } from "./utility/tooltip";
import { documentsToDownloadCMR,documentsToDownload } from "../../utils/utils";

export async function AvisTableData(supplierId, pageSize, pageNumber, deleteSO) {

  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/forwarder/avis/getAvisOrdersByProviderId/${supplierId}/` +
      pageNumber +
      `/` +
      pageSize +
      `/` +
      "zSort" +
      `/` +
      "desc";

      const requestOptions = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            "Access-Control-Allow-Origin": API_ROOT,
        },
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    const result = await response.json();
    console.log(result);

    const tableData = result.data.pickupPage.content.map((order) => {
      if (result) {
        if (order.color === "GREY") {
          order.colorcode = (
            <span>
              <Tooltip
                title={!_.isEmpty(order.statusText) ? order.statusText : ""}
              >
                <svg height="24" width="24" viewBox="0 0 50 50">
                  <path
                    fill="#919191"
                    d="M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z"
                  />
                </svg>
              </Tooltip>
            </span>
          );
        } else if (order.color === "YELLOW") {
          order.colorcode = (
            <span>
              <Tooltip
                title={!_.isEmpty(order.statusText) ? order.statusText : ""}
              >
                <svg height="24" width="24" viewBox="0 0 50 50">
                  <path
                    fill="#ffde00"
                    d="M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z"
                  />
                </svg>
              </Tooltip>
            </span>
          );
        } else if (order.color === "RED") {
          order.colorcode = (
            <span>
              <Tooltip
                title={!_.isEmpty(order.statusText) ? order.statusText : ""}
              >
                <svg height="24" width="24" viewBox="0 0 50 50">
                  <path
                    fill="#FF0000"
                    d="M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z"
                  />
                </svg>
              </Tooltip>
            </span>
          );
        } else if (order.color === "WARN") {
          order.colorcode = (
            <span>
              <Tooltip
                title={!_.isEmpty(order.statusText) ? order.statusText : ""}
              >
                <svg height="24" width="24" viewBox="0 0 50 50">
                  <path
                    fill="#FF0000"
                    d="M24 42q-1.45 0-2.475-1.025Q20.5 39.95 20.5 38.5q0-1.45 1.025-2.475Q22.55 35 24 35q1.45 0 2.475 1.025Q27.5 37.05 27.5 38.5q0 1.45-1.025 2.475Q25.45 42 24 42Zm-3.5-12V6h7v24Z"
                  />
                </svg>
              </Tooltip>
            </span>
          );
        }

        if (order.links.length > 0) {
          if (order.links[0].rel) {
            const cmrLinks = order.links.filter(
              (link) => link.rel.includes("CMR")
            );
            const soLink = order.links.filter(
              (link) => link.rel.includes("SO")
            );
            const transitApprovalLink = order.links.filter(
              (link) => link.rel.includes("TA")
            );

            const updatedTransitApprovalLinks = order.links
              .filter((link) => link.rel.includes("TA"))
              .map((link, index) => {
                let url = link.href;

                // Replace "http" with "https"
                url = url.replace("http", "https");
                
                // Prepend REST_URL if it's not included in the URL
                if (!url.includes(REST_URL)) {
                  url = REST_URL + link.href;
                }
                
                // Return an object with both the updated URL and the file name
                return {
                  url: url,
                  fileName: link.rel,
                };
              })
              .filter((item) => item !== null); 

            order.ta_links = updatedTransitApprovalLinks;

            const updatedVesselDocumentLinks = order.links
              .filter((link) => link.rel.includes("VD"))
              .map((link, index) => {
                let url = link.href;

                // Replace "http" with "https"
                url = url.replace("http", "https");
                
                // Prepend REST_URL if it's not included in the URL
                if (!url.includes(REST_URL)) {
                  url = REST_URL + link.href;
                }
                
                // Return an object with both the updated URL and the file name
                return {
                  url: url,
                  fileName: link.rel,
                };
              })
              .filter((item) => item !== null);
            order.vd_links = updatedVesselDocumentLinks;
            // let link = order.links;
            order.links = (
              <span className="flex items-center">
                {soLink.length > 0 ? (
                  <a onClick={() => documentsToDownload(soLink)}>
                    <CustomToolTipDownload title="Download" />
                  </a>
                ) : null}
                {cmrLinks.length > 0 ? (
                  <a onClick={() => documentsToDownloadCMR(cmrLinks)}>
                    <CustomToolTipCMR title="Download CMR" />
                  </a>
                ) : null}
              </span>
            );
          }
        }

        //comar nums
        let comarNums = order.zcomar.replaceAll(",", ", ");
        order.zcomar = comarNums;

        //Delete Shipping Order is disable for orders which are shipped and not load build
        if (order.buildId !== 0) {
          order.delete = (
            <a onClick={() => deleteSO(order)}>
              <CustomToolTipDelete title="Delete SO" />
            </a>
          );
        }
      }
      return order;
    });
    return {
      tableData,
      locationList: result.data.locationList,
      imolist: result.data.imolist,
    };
  } catch (error) {
    console.log(error);
    return { tableData: [], locationList: [], imolist: [] };
  }
}

const notifyFailure = (message) => {
  toast.error(message);
};
const notifySuccess = (message) => {
  toast.success(message);
};
export const deleteSORequest = (reqObj,handleCloseLoader,handleTableRefresh) =>{
  let url = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/deleteShippingOrder`;
    const requestOptions = {
      method: "DELETE",
      body: JSON.stringify(reqObj),
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
        "Content-Type": "application/json",
      },
    };

    fetch(url, requestOptions).then((response) => {
      if (response["status"] == 200) {
        handleCloseLoader();
        handleTableRefresh();
        notifySuccess("Selected shipping order has been deleted successfully");
      } else if (response["status"] == 401) {
        handleCloseLoader();
        notifyFailure("You don't have access to delete shipping order!");
      } else {
        handleCloseLoader();
        notifyFailure("Delete shipping order failed!");
      }
    });
}

export async function reportPickup(reqObj){
  let url = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/reportPickup`;
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqObj),
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
        "Content-Type": "application/json",
      },
    };
  const response = await fetch(url, requestOptions);
  const result = await response.json();
  log('reportPickup response-- ', result);  
  return result;
}
